import { useMutation, useQuery, useQueryClient } from 'react-query'
import { createMessage } from '../../api/messages'

export function useCreateMessageMutation(payload, successCallback) {
  const options = { onSuccess: successCallback }
  return useMutation(direction => createMessage(payload), options)
}
